import { render } from "./DettaglioProgetto.vue?vue&type=template&id=25c3ff82&ts=true"
import script from "./DettaglioProgetto.vue?vue&type=script&lang=ts"
export * from "./DettaglioProgetto.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__